import { motion } from "framer-motion";
import { Check } from "lucide-react";

const points = [
  "Qualified property handyman · fully insured",
  "Based in Warwickshire — covering surrounding areas",
  "Direct line to the person doing the work",
  "End-of-tenancy checklist matched to letting agents' standards",
];

export default function About() {
  return (
    <section id="about" className="py-24 sm:py-32 border-t border-[#0B1215]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5 order-2 lg:order-1"
          >
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src="/about-hero.jpg"
                alt="Hand-polishing a deeply finished timber surface"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
              <div className="absolute bottom-6 left-6 bg-[#0B1215] text-[#F8F9FA] p-5 max-w-[240px]">
                <div className="font-mono-label text-[#FF5A36] mb-2">· FRESH START · OLD HABITS</div>
                <p className="text-sm leading-relaxed">
                  A new venture — backed by years of hands-on property experience.
                </p>
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="font-mono-label text-[#FF5A36] mb-4">· ABOUT THE CURATOR</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0B1215] tracking-tighter leading-[0.95]">
              Qualified handyman.<br />
              <span className="italic font-light">Local</span> roots.
            </h2>
            <p className="mt-8 text-[#495057] text-lg leading-relaxed max-w-xl">
              After years of letting agents watching tenancies go wrong for the sake of a proper clean,
              The Property Curator was set up to do one thing right: take a property from whatever
              state it's in, and hand it back ready for the next set of keys.
            </p>
            <p className="mt-4 text-[#495057] leading-relaxed max-w-xl">
              No sales calls. No agency fees stacked on top. Just a qualified, insured tradesperson who
              turns up when he says he will and leaves the property better than he found it.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <div className="mt-1 w-6 h-6 bg-[#FF5A36] text-[#F8F9FA] flex items-center justify-center shrink-0">
                    <Check size={14} strokeWidth={3} />
                  </div>
                  <span className="text-sm text-[#0B1215]">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
